import { render, staticRenderFns } from "./task-edit-mode.vue?vue&type=template&id=42fc289a&scoped=true&"
import script from "./task-edit-mode.vue?vue&type=script&lang=js&"
export * from "./task-edit-mode.vue?vue&type=script&lang=js&"
import style0 from "./task-edit-mode.vue?vue&type=style&index=0&id=42fc289a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fc289a",
  null
  
)

export default component.exports